<template>
  <v-container
    class="content"
  >
    <v-row
      justify="center"
      align-content="center"
      align="center"
      no-gutters
    >
      <v-col
        cols="6"
        sm="3"
        md="3"
        lg="5"
        xl="4"
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-img
            class="logoH"
            src="../assets/img/logo_h.svg"
          />
          <v-img
            class="logoV"
            src="../assets/img/logo_v.svg"
          />
        </v-row>
      </v-col>

      <v-col
        cols="6"
        sm="4"
        md="4"
        lg="5"
        xl="4"
        offset="1"
      >
        <v-card
          tile
          class="transparent"
          flat
        >
           <v-card
              flat
              tile
              class="titleCard transparent"
            >
              <p class="titlePluris">9° Congresso Luso-Brasileiro </p>
              <p class="titlePluris">para o Planejamento Urbano, </p>
              <p class="titlePluris">Regional, Integrado e Sustentável</p>
            </v-card>
            <v-card
              flat
              tile
              class="dateAndPlaceCard transparent"
            >
              <p class="date">
                <span class="newDate">
                  Nova data!
                </span>
                <span class="spanDate">
                  07
                </span> a
                <span class="spanDate">
                  09
                </span>
                de abril de
                <span class="spanDate">
                  2021
                </span>
              </p>
              <p class="place">
                 <span class="spanPlace">
                  <strike>Águas de Lindóia - SP</strike>
                </span>
                <strike>- Brasil</strike>
              </p>
              <p class="place">
                 <span class="spanDate">
                  CONGRESSO DIGITAL
                </span>
              </p>
            </v-card>
        </v-card>
      </v-col>

      <Languages class="languages" />
    </v-row>
  </v-container>
</template>

<script>
import Languages from './Languages.vue';

export default {
  name: 'ContentHome',
  components: {
    Languages,
  },
};
</script>

<style scoped>
.logoH,
.logoV {
    display: none;
}

/* Textos */

.titlePluris {
  font-weight: 600;
  color: var(--v-tertiary-base);
  text-align: left;
  letter-spacing: 0.0125em;
  font-size: calc(6.5px + (22 - 6.5) * ((100vw - 300px) / (1920 - 300)));
  line-height: calc(8.5px + (28 - 8.5) * ((100vw - 300px) / (1920 - 300)));
}

.date {
  color: var(--v-text-base);
  font-weight: 600;
  text-align: left;
  font-size: calc(7.5px + (28 - 7.5) * ((100vw - 300px) / (1920 - 300)));
  line-height: calc(10px + (32 - 10) * ((100vw - 300px) / (1920 - 300)));
}

.place {
  color: var(--v-text-base);
  font-weight: 600;
  text-align: left;
  font-size: calc(7.5px + (28 - 7.5) * ((100vw - 300px) / (1920 - 300)));
  line-height: calc(10px + (32 - 10) * ((100vw - 300px) / (1920 - 300)));
}

.card {
  padding: 20px;
}

/* ----- */

.dateAndPlaceCard,
.titleCard {
  padding-top: 5px;
  padding-bottom: 5px;
}

.transparent {
  background-color: transparent;
}

.logoV {
  display: none;
}

.logoH {
  display: flex;
}

.spanPlace {
  font-weight: 700;
}

.spanDate {
  color: var(--v-tertiary-base);
  font-weight: 700;
}


/*
 xl - 4k and ultra-wides> 1904px*

*/

@media (min-width: 1905px) {
  .content {
    margin-top: 15vh;
  }

  .languages {
    margin-top: 2rem;
  }

  .logoH {
    max-width: 30vw;
  }
}

/*
  lg - desktop 1264px*><1904px*
*/

@media (min-width: 1265px) and (max-width: 1904px) {
  .content {
    margin-top: 10vh;
  }

  .languages {
    margin-top: 2rem;
  }

  .logoH {
    max-width: 30vw;
  }
}

/*
  md - large tablet to laptop960px><1264px*
*/

@media (min-width: 960px) and (max-width: 1264px) {
  .content {
    margin-top: 4rem;
  }

  .languages {
    margin-top: 2rem;
  }
}

/*
  sm - small to medium tablet600px><960px
*/

@media (min-width: 600px) and (max-width: 959px) {
  .content {
    margin-top: 2rem;
  }

  .languages {
    margin-top: 1rem;
  }
}

/*
  xs - small to large handset<600px

*/

@media screen and (max-width: 599px) {

}

@media screen and (min-width: 600px) {
  .logoH {
    display: flex;
  }

  .logoV {
    display: none;
  }
}

.v-application p {
  margin-bottom: 0px;
}

.newDate {
  color: red;
}
</style>
